"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTransactions = toTransactions;

var _xxhashjs = _interopRequireDefault(require("xxhashjs"));

var _fastJsonStableStringify = _interopRequireDefault(require("fast-json-stable-stringify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toTransactions(transactions) {
  const items = {};
  transactions.forEach(transaction => {
    const {
      request,
      response
    } = transaction;

    const requestHash = _xxhashjs.default.h32((0, _fastJsonStableStringify.default)(request), 0xabcde).toString(16);

    if (!Object.keys(items).includes(requestHash)) {
      items[requestHash] = {
        request,
        responses: [response]
      };
    } else {
      items[requestHash].responses.push(response);
    }
  });
  return Object.values(items);
}